<script >
import { useQueryClient } from '@tanstack/vue-query';
import { defineProps } from '@vue/composition-api';
import { default as FormEditBank } from './form/formEditBank';
import { default as DropdownTable } from '@/components/dropdownTable';
import { default as Alert } from '@/components/alert';
import { useModal } from '@/composable/useModal';
import { addingLoading, closeLoading } from '@/utils/handleControlLoading';
import getMessageError from '@/utils/getMessageError';
import { bankService } from '@/api/transfer/bank';
import { getToastContentComponent } from '@/utils/getToastContentComponent';
import { toast } from '@/utils/programaticToast';
const __sfc_main = {};
__sfc_main.props = {
  row: {
    type: Object
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;

  /* edit bank */
  const {
    isOpen: isOpenModalEdit,
    handleVisibility: handleVisibilityModalEdit
  } = useModal();

  /* delete bank */
  const {
    isOpen: isOpenModalDelete,
    handleVisibility: handleVisibilityModalDelete
  } = useModal();
  const queryClient = useQueryClient();
  async function handleDelete() {
    try {
      addingLoading();
      await bankService.delete(props.row.id);
      toast.open({
        variant: 'success',
        position: 'bottom',
        component: getToastContentComponent({
          title: 'Excluído com sucesso',
          describe: 'Dados bancários foi excluído com sucesso',
          typeIcon: 'success'
        }),
        closable: true,
        duration: 4000
      });
      queryClient.invalidateQueries({
        queryKey: ['banks']
      });
      handleVisibilityModalDelete();
    } catch (error) {
      toast.open({
        variant: 'error',
        position: 'bottom',
        component: getToastContentComponent({
          title: 'Ocorreu um erro',
          describe: getMessageError(error),
          typeIcon: 'error'
        }),
        closable: true,
        duration: 4000
      });
    } finally {
      closeLoading();
    }
  }
  return {
    isOpenModalEdit,
    handleVisibilityModalEdit,
    isOpenModalDelete,
    handleVisibilityModalDelete,
    handleDelete
  };
};
__sfc_main.components = Object.assign({
  DropdownTable,
  FormEditBank,
  Alert
}, __sfc_main.components);
export default __sfc_main;
</script>

<template>
  <div>
    <DropdownTable aria-role="list">
      <o-dropdown-item aria-role="listitem" @click="handleVisibilityModalEdit">
        {{ $t('bank.edit') }}
      </o-dropdown-item>

      <o-dropdown-item aria-role="listitem" @click="handleVisibilityModalDelete">
        {{ $t('bank.delete') }}
      </o-dropdown-item>
    </DropdownTable>

    <o-modal :active="isOpenModalEdit" width="560" @close="handleVisibilityModalEdit">
      <div>
        <h2 class="header-2">{{ $t('bank.editTitle') }}</h2>
        <p class="paragraph">{{ $t('bank.editParagraph') }}</p>
      </div>

      <FormEditBank :bank-data="row" :close-modal="handleVisibilityModalEdit" />
    </o-modal>

    <Alert
      :active="isOpenModalDelete"
      @handleClose="handleVisibilityModalDelete"
    >
      <template #title> {{ $t('bank.deleteTitle') }} </template>
      <template #message> {{ $t('bank.deleteParagraph') }} {{ row.shipping_company_name }} </template>

      <template #buttons>
        <o-button variant="outline" size="md" @click="handleVisibilityModalDelete"> {{ $t('bank.buttonCancel') }} </o-button>
        <o-button variant="primary" size="md" @click="handleDelete"> {{ $t('bank.buttonDelete') }} </o-button>
      </template>
    </Alert>
  </div>
</template>
